export function fmtUsd(n, digits) {
  if (n == null || Number.isNaN(n)) return "—";
  if (n >= 1e9) return "$" + (n / 1e9).toFixed(2) + "B";
  if (n >= 1e6) return "$" + (n / 1e6).toFixed(2) + "M";
  if (n >= 1e3) return "$" + (n / 1e3).toFixed(1) + "K";
  if (n < 0.01) return "$" + n.toFixed(digits ?? 7);
  return "$" + n.toFixed(2);
}

export function fmtInt(n) {
  if (n == null || Number.isNaN(n)) return "—";
  return Math.round(n).toLocaleString();
}

export function fmtCompact(n) {
  if (n == null || Number.isNaN(n)) return "—";
  if (n >= 1e9) return (n / 1e9).toFixed(2) + "B";
  if (n >= 1e6) return (n / 1e6).toFixed(2) + "M";
  if (n >= 1e3) return (n / 1e3).toFixed(1) + "K";
  return Math.round(n).toLocaleString();
}

export function fmtPct(n, digits = 2) {
  if (n == null || Number.isNaN(n)) return "—";
  return n.toFixed(digits) + "%";
}
